import React from 'react';
import {  Container } from 'react-bootstrap';

const Footer = () => {
  return (
    <footer>
        <Container className='text-center py-3' >
            Copyrights &copy; Brewhaus. All rights reserved. 
        </Container>
    </footer>
  )
}

export default Footer